import React from 'react';
import { Grid, makeStyles, Theme } from '@material-ui/core';
import { ExclamationCircleIcon } from '../../../icon/solid';

export const useStyles = makeStyles(({ palette: { text } }: Theme) => ({
  exclamationIcon: {
    color: '#F8221A',
    fontSize: 32,
    marginBottom: 11,
  },

  text: {
    fontSize: 14,
    color: text.secondary,
    textAlign: 'center',
  },
}), { name: 'mediaFileMissingMessageStyles' });


export default function MediaFileMissingMessage() {
  const classes = useStyles();

  return (
    <Grid container justify="center" direction="column" alignItems="center">
      <ExclamationCircleIcon className={classes.exclamationIcon} />
      <span className={classes.text}>
        Media file missing.
        <br />
       Please select a Media item.
      </span>
    </Grid>
  );
}
